// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"b7459595","833":"b7459595"}[chunkId] + ".chunk.css";
};